import { ContactModelBase } from 'Models/ContactModel';
import { ContactModelV2 } from 'Models/ContactModelV2';

export const mapContactCategory = (
  contact: ContactModelV2 | ContactModelBase
) => {
  try {
    if (contact instanceof ContactModelBase) {
      return '';
    }

    if (contact.source === 'Bhive') {
      return 'Directory contact';
    }

    return contact.sourceData.type === 'personal'
      ? 'Personal contact'
      : contact.sourceData.type === 'shared'
      ? 'Organization contact'
      : 'External source';
  } catch (error) {
    return '';
  }
};
